import React, { useState } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavbarText
} from 'reactstrap';

function Header (){
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  return (
     <Navbar className="cabecera" dark expand="md">
       <NavbarBrand className="elPaddingImg">
         <img
            src="http://crdascz.com/CRDASCZ/wp-content/uploads/2021/01/cropped-LogoCRDASC_H04-2048x878.png"
            width="160"
            height="70"
            className="d-inline-block align-top elLogo"
            alt="React Bootstrap elLogo"
          />
        </NavbarBrand>
       <NavbarToggler onClick={toggle} />
       <Collapse isOpen={isOpen} navbar>
         <Nav className="ml-auto elPadding" navbar>
           <NavItem className="itemMenu">
             <NavLink href="http://crdascz.com/CRDASCZ/">Inicio</NavLink>
           </NavItem>
           <NavItem className="itemMenu">
             <NavLink href="http://crdascz.com/CRDASCZ/about/">Institucional</NavLink>
           </NavItem>
           <NavItem className="itemMenu">
             <NavLink href="http://crdascz.com/CRDASCZ/departments/">Servicios</NavLink>
           </NavItem>
           <NavItem className="itemMenu">
             <NavLink href="http://comunicacion.crdascz.com/encontexto.php">Blog Institucional</NavLink>
           </NavItem>
           <NavItem className="itemMenu">
             <NavLink href="http://crdascz.com/CRDASCZ/contact/">Contáctenos</NavLink>
           </NavItem>
           <NavItem className="itemMenu">
             <NavLink href="https://sistema.siga.com.bo/">
               <span id="siga">
                SIGA
                <img className=" img-fluid" src="https://siga.com.bo/wp-content/uploads/2020/12/cropped-iconosiga-192x192.png" alt="logo"/>
               </span>
              </NavLink>
           </NavItem>
           {/*<UncontrolledDropdown nav inNavbar>
             <DropdownToggle nav caret>
               Options
             </DropdownToggle>
             <DropdownMenu right>
               <DropdownItem>
                 Option 1
               </DropdownItem>
               <DropdownItem>
                 Option 2
               </DropdownItem>
               <DropdownItem divider />
               <DropdownItem>
                 Reset
               </DropdownItem>
             </DropdownMenu>
           </UncontrolledDropdown>*/}
         </Nav>
       </Collapse>
     </Navbar>
  )
}

export default Header;
